import instance from "services/axiosServices";

/**
 * @function getListarSolicitacoes
 * @param {Object} params - parâmetros.
 * @param {string} params.idEmpreendimento - GUID do empreendimento.
 * @param {Date | null} params.dataInicioPeriodoCriacao - data de início.
 * @param {Date | null} params.dataFimPeriodoCriacao - data de fim.
 * @returns {Promise<any>} - retorna confirmação da request.
 */
export const getListarSolicitacoes = async (params: {
  idEmpreendimento: string;
  dataInicioPeriodoCriacao: Date | null;
  dataFimPeriodoCriacao: Date | null;
}): Promise<any> => {
  const url_base = "locais/admin/solicitacaoVisita/listar-solicitacao/v1";
  const url = `${url_base}?idEmpreendimento=${
    params.idEmpreendimento
  }&dataInicioPeriodoCriacao=${
    params.dataInicioPeriodoCriacao
      ? params.dataInicioPeriodoCriacao?.toISOString()
      : ""
  }&dataFimPeriodoCriacao=${
    params.dataFimPeriodoCriacao
      ? params.dataFimPeriodoCriacao?.toISOString()
      : ""
  }`;
  const response = await instance.get(url);
  return response?.data;
};
